import { NavLink, Outlet } from 'react-router-dom';
import { LayoutDashboard, Wallet, Award, Users, Settings, Layers, ShieldCheck, Handshake } from 'lucide-react';
import Navbar from '@/components/Navbar';
import { useAuth } from '@/contexts/AuthContext';

const items = [
  { to: '/dashboard', label: 'Overview', icon: LayoutDashboard, testId: 'side-overview' },
  { to: '/accounts', label: 'Accounts', icon: Layers, testId: 'side-accounts' },
  { to: '/payouts', label: 'Rewards', icon: Wallet, testId: 'side-payouts' },
  { to: '/payment-agents', label: 'Payment Agents', icon: Handshake, testId: 'side-agents' },
  { to: '/certificates', label: 'Certificates', icon: Award, testId: 'side-certs' },
  { to: '/affiliate', label: 'Affiliate', icon: Users, testId: 'side-affiliate' },
  { to: '/settings', label: 'Settings', icon: Settings, testId: 'side-settings' },
];

export default function AppShell() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      <div className="max-w-[1400px] mx-auto px-5 sm:px-6 py-8 grid grid-cols-1 lg:grid-cols-[240px_1fr] gap-8">
        <aside className="lg:sticky lg:top-24 h-fit">
          <div className="card-tech rounded-lg p-4">
            <div className="label-sm mb-3">Trader hub</div>
            <div className="space-y-1">
              {items.map(it => (
                <NavLink key={it.to} to={it.to} end={it.to === '/dashboard'}
                  className={({ isActive }) =>
                    `flex items-center gap-2.5 px-3 py-2 rounded-md text-sm transition
                     ${isActive ? 'bg-[#00ff66]/10 text-white border border-[#00ff66]/30' : 'text-zinc-400 hover:text-white hover:bg-white/5 border border-transparent'}`
                  }
                  data-testid={it.testId}
                >
                  <it.icon size={15} /> {it.label}
                </NavLink>
              ))}
              {user?.role === 'admin' && (
                <NavLink to="/admin" className="flex items-center gap-2.5 px-3 py-2 rounded-md text-sm text-[#00ff66] hover:bg-[#00ff66]/10 border border-transparent" data-testid="side-admin">
                  <ShieldCheck size={15} /> Admin
                </NavLink>
              )}
            </div>
          </div>
        </aside>
        <main><Outlet /></main>
      </div>
    </div>
  );
}
